import React from "react";

import { Route, Routes } from "react-router-dom";
import AllEligibilityCriteriaPage from "./eligibility.all";
import AddEligibilityPage from "./eligibility.add";

const EligibilityPage = () => {
  return (
    <>
      <Routes>
        <Route element={<AddEligibilityPage />} path="add" />
        <Route
          element={<AllEligibilityCriteriaPage />}
          path="/dashboard/organization/:id"
        />
        <Route element={<AllEligibilityCriteriaPage />} path="" />
      </Routes>
    </>
  );
};

export default EligibilityPage;
